export const UploadIconComponent = () => {
    return (
        <div>
            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.49992 13.6667V8.66675L5.83325 10.3334" stroke="#6B6969" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.5 8.66675L9.16667 10.3334" stroke="#6B6969" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                    d="M18.3334 7.83341V12.0001C18.3334 16.1667 16.6667 17.8334 12.5001 17.8334H7.50008C3.33341 17.8334 1.66675 16.1667 1.66675 12.0001V7.00008C1.66675 2.83341 3.33341 1.16675 7.50008 1.16675H11.6667"
                    stroke="#6B6969"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M18.3334 7.83341H15.0001C12.5001 7.83341 11.6667 7.00008 11.6667 4.50008V1.16675L18.3334 7.83341Z"
                    stroke="#6B6969"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
    );
};
